export const styles = {
  article: {
    flex: 1,
    alignItems: "flex-start",
    textAlign: "left",
    gap: 1.5,
    cursor: "pointer",
    transition: "transform 0.3s ease, opacity 0.3s ease",
    "&:hover": {
      opacity: 0.85,
      transform: "translateY(-4px)",
    },
    "@media (max-width: 1100px)": {
      maxWidth: 600,
    },
  },
  imgWrapper: {
    borderRadius: 2.5,
    overflow: "hidden",
    width: "100%",
  },
  img: {
    width: "100%",
    height: "220px",
    display: "block",
    objectFit: "cover" as const,
  },
  title: {
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
};
